module.exports = __webpack_public_path__ + "static/media/expert-chat-welcome-team.daa90f58.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/expert-chat-welcome-team.jpg
// module id = 1398
// module chunks = 0